import dictionaries from '@resider/dictionaries';
import filters from '../store';
import { get } from 'svelte/store';

/**
 * @param {Event} e
 * @param {String} value
 */
export default function addLocation(e, value) {
	if (typeof value !== 'string' || !value.match(/,/)) return;

	e.preventDefault();
	e.stopPropagation();

	// const [a, b] = value.split(', ');
	const [a] = value.split(', ');

	if (
		get(filters).district &&
		Object.values(dictionaries.locations.districts['warszawa']).some((x) => x === a)
	) {
		filters.update((/** @type {any} */ store) => ({ ...store, district: [...new Set([...store.district, a])] }));
	}
	if (
		get(filters).subdistrict &&
		Object.values(dictionaries.locations.subdistricts['warszawa']).some((x) => x === a)
	) {
		filters.update((/** @type {any} */ store) => ({ ...store, subdistrict: [...new Set([...store.subdistrict, a])] }));
	}
}
